module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_vi-965385c77d037646bb69899ff880835f.jpg";